import { isHttpErrorWithId } from './is-http-error-with-id';
export function isSupportAccessDeniedError(error) {
    return isHttpErrorWithId(error, 403, 'ORGANIZATION_SUPPORT_ACCESS_NOT_GRANTED');
}
